import React, { Component } from 'react';
import cx from 'classnames';
import Text from '../../Text';
import Icon from '../../Icon';

import '../styles/_drawer-grid-list.scss';













export default class DrawerGridList extends Component {
  static defaultProps = {
    listItems: [],
    emptyListContent: {}
  };

  constructor(props) {
    super(props);
    this.state = {
      showList: true
    };
  }

  listItemClicked = (itemId) => {
    const { removeItem } = this.props;
    removeItem(itemId);
  };

  render() {
    const {
      headerTitle,
      headerIconName,
      listItems,
      emptyListContent
    } = this.props;

    const {
      showList
    } = this.state;

    return (
      showList &&

      <div className={cx('drawer-grid-list', { 'drawer-grid-list--empty-list': listItems.length > 0 })}>

          <div className="drawer-grid-list-header">
            <Icon
            className="drawer-grid-list-header--grid-list-icon"
            name={headerIconName || 'addfolder'}
            size={20} />

            <Text heading4>
              {headerTitle}
              {' '}
              (
              {listItems.length}
              )
            </Text>
          </div>

          {listItems.length === 0 ?
        <div className="drawer-grid-list__empty-list">
              <div className="drawer-grid-list__empty-list__image" />
              <Text heading4>{emptyListContent.heading}</Text>
              <Text>{emptyListContent.text}</Text>
            </div> :

        <ul className="drawer-grid-list-body">
              {listItems.map((item) =>
          <li key={item.id} className="drawer-grid-list-body__item">
                  {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
                  <div
              className="drawer-grid-list-body__item--selected"
              onClick={() => this.listItemClicked(item.id)}
              role="presentation">

                    <Icon
                name="partial"
                size={10} />

                  </div>
                  <div className="drawer-grid-list-body__item__inner-item">
                    <div
                className="item-image"
                style={{
                  backgroundImage: `url(${item.thumbnailUrl && item.thumbnailUrl.sourceUrl ?
                  item.thumbnailUrl.sourceUrl :
                  ''
                  })`
                }}>

                      <div className="item-image__asset-type">
                        <Icon
                    className="drawer-grid-list-header--grid-list-icon"
                    name={item.typeIcon ? item.typeIcon : 'video'}
                    size={15} />

                      </div>
                    </div>
                    <Text>{item.name}</Text>
                  </div>
                </li>
          )}
            </ul>}


        </div>);


  }
}